const desc = `
<p>על <span class="bold">בכפר ובעבודה - גלים</span> יז טבת תר"צ [1930 01 17]</p>
`;
export default desc;
